import detailsEvaluationBoutique from "./detailsEvaluationBoutique"
export default detailsEvaluationBoutique;
